module.exports = __webpack_public_path__ + "img/HausMitRädern.14693174.svg";